import LinkedInIcon from "@mui/icons-material/LinkedIn";
import {
  Box,
  Container,
  Grid,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import SEO from "../../components/SEO";

const AboutUs = () => {
  const teamMembers = [
    {
      name: "Amit Ruhela",
      image: "/founder1.webp", // use webp for optimization
      designation: "Co Founder",
      description:
        "A highly accomplished professional bringing two decades of rich experience within the banking and NBFC landscape. Possessing a deep understanding of both retail and working capital loan products, with a specific focus on empowering the MSME sector. Demonstrated success in managing and scaling large teams and distribution channels to achieve significant business objectives.",
      linkedin: "https://www.linkedin.com/in/amitruhela/",
    },
    {
      name: "Ankur Singh",
      image: "/founder2.webp", // use webp for optimization
      designation: "Co Founder",
      description:
        "A results-oriented professional offering a unique blend of 18 years of deep financial expertise gained within MNC banks – encompassing rigorous credit underwriting and the strategic oversight of substantial SME asset portfolios – alongside the practical, hands-on experience of successfully launching and scaling a consumer tech business from scratch. This dual background provides a comprehensive understanding of both financial risk management and market-driven innovation.",
      linkedin: "https://www.linkedin.com/in/ankursingh1",
    },
  ];

  return (
    <>
      <SEO
        title="About Dequitec | MSME Loan Experts & Business Vision"
        description="Discover Dequitec’s expertise in working capital loans and loan against property, helping businesses achieve fast funding and sustainable growth."
        canonical="https://www.dequitec.com/about-us"
      />
      <Container maxWidth="lg" sx={{ marginBottom: "4rem" }}>
        {/* Centered Line & Title */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            marginTop: "1%",
          }}
        >
          <Box
            sx={{ width: "40px", height: "2px", backgroundColor: "#004AAD" }}
          />
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", color: "#004AAD" }}
          >
            About Us
          </Typography>
        </Box>

        {/* Section 1 */}
        <Grid container spacing={8} alignItems="center" justifyContent="center">
          <Grid item xs={12} md={6} lg={3}>
            <Paper elevation={0} sx={{ borderRadius: 2, padding: 4 }}>
              <img
                src="/AboutUsBanner.webp"
                alt="About Dequitec"
                loading="lazy"
                width="100%"
                height="200"
                style={{
                  borderRadius: "12px",
                  objectFit: "contain",
                  maxHeight: "25vh",
                }}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <Typography variant="h5" gutterBottom>
              Dequitec helps MSMEs/SMEs to raise funds in lightning speed.
            </Typography>
            <Typography style={{ fontSize: "0.9rem", fontWeight: 300 }}>
              We help small and medium businesses achieve sustainable growth.
              Our technology-driven platform is designed to efficiently arrange
              capital and provide crucial advisory services. We go beyond simple
              matchmaking to help you secure the best-fit financing and equip
              you with the strategic insights necessary for long-term success.
              <br />
              <br />
              We function as a technology-enabled consultant, not just a loan
              aggregator. Our process involves a thorough analysis of your
              funding requirements and creditworthiness, ensuring that your
              proposal is submitted to a carefully selected group of relevant
              financiers for the most favorable funding arrangement.
            </Typography>
          </Grid>
        </Grid>

        {/* Section 2 */}
        <Box textAlign="center" my={6}>
          <Typography variant="subtitle1" fontStyle="italic">
            We are a team of credit and technology experts that are building the
            next generation of credit tools for faster and efficient business
            lending.
          </Typography>
        </Box>

        {/* Centered Line & Title */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            marginTop: "1%",
          }}
        >
          <Box
            sx={{ width: "40px", height: "2px", backgroundColor: "#004AAD" }}
          />
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", color: "#004AAD" }}
          >
            Team
          </Typography>
        </Box>

        <Box textAlign="center" marginTop={1}>
          <Typography
            variant="h6"
            sx={{
              mt: 1,
              mb: 2,
              fontWeight: "bold",
              color: "#333333",
              textAlign: "center",
            }}
          >
            The Founding Team
          </Typography>
        </Box>

        {/* Section 3 - Team Members */}
        <Grid container spacing={4} justifyContent="center">
          {teamMembers.map((member, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={index}
              sx={{ marginBottom: { xs: "2rem" } }}
            >
              <Paper
                elevation={0}
                sx={{
                  textAlign: "left",
                  padding: 3,
                  borderRadius: 2,
                  boxShadow: "none",
                  position: "relative",
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "200px",
                    width: "200px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "50%",
                    marginBottom: "20px",
                    marginX: "auto",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={member.image}
                    alt={member.name}
                    loading="lazy"
                    width="200"
                    height="200"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "left",
                    gap: 2,
                  }}
                >
                  <Box
                    sx={{
                      width: "15px",
                      height: "1px",
                      backgroundColor: "#004AAD",
                    }}
                  />
                  <Typography fontWeight="bold" color="#333333">
                    {member.name}
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ marginBottom: "16px" }}
                >
                  {member.designation}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontSize: "0.95rem", textAlign: "left" }}
                >
                  {member.description}
                </Typography>

                {/* LinkedIn Icon with accessibility fix */}
                <IconButton
                  href={member.linkedin}
                  target="_blank"
                  aria-label={`LinkedIn profile of ${member.name}`}
                  title={`Connect with ${member.name} on LinkedIn`}
                  sx={{
                    position: "absolute",
                    bottom: 10,
                    left: 10,
                    backgroundColor: "#0077B5",
                    color: "white",
                    "&:hover": { backgroundColor: "#005C8C" },
                  }}
                >
                  <LinkedInIcon />
                </IconButton>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
};

export default AboutUs;
